import { useEffect, useRef, useState } from 'react';
import { useStore } from '../store';
import { fetchApiToken } from '../api';

// Overflow menu: everything that is useful but not daily-use.
export function MoreMenu() {
  const [open, setOpen] = useState(false);
  const [tokenNote, setTokenNote] = useState<string | null>(null);
  const repoUrl = useStore((s) => s.repoUrl);
  const setHelpOpen = useStore((s) => s.setHelpOpen);
  const setSubmitOpen = useStore((s) => s.setSubmitOpen);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const copyToken = async () => {
    try {
      const token = await fetchApiToken();
      await navigator.clipboard.writeText(token);
      setTokenNote('Token copied. Use it as Authorization: Bearer or `xss login <token>`.');
    } catch (e) {
      setTokenNote(`Failed: ${(e as Error).message}`);
    }
    window.setTimeout(() => setTokenNote(null), 4000);
  };

  return (
    <div className="menu-wrap" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="More"
        aria-haspopup="menu"
        aria-expanded={open}
        title="Docs, shortcuts, API token"
      >
        ⋯
      </button>
      {open && (
        <div className="more-menu" role="menu">
          <a href="/docs" target="_blank" rel="noreferrer" role="menuitem">Docs</a>
          <a href="/llms.txt" target="_blank" rel="noreferrer" role="menuitem">LLM reference (llms.txt)</a>
          <button
            type="button"
            role="menuitem"
            aria-label="Help"
            title="Keyboard shortcuts (?)"
            onClick={() => {
              setOpen(false);
              setHelpOpen(true);
            }}
          >
            Keyboard shortcuts
          </button>
          <button
            type="button"
            role="menuitem"
            className="payload-submit"
            title="Submit the current editor state to the public payload library"
            onClick={() => {
              setOpen(false);
              setSubmitOpen(true);
            }}
          >
            Submit to library…
          </button>
          <button type="button" role="menuitem" onClick={() => void copyToken()} title="Copy your owner token for the CLI / API">
            Copy API token
          </button>
          {repoUrl && (
            <a href={repoUrl} target="_blank" rel="noreferrer" role="menuitem">GitHub</a>
          )}
          {tokenNote && <p className="more-menu-note">{tokenNote}</p>}
        </div>
      )}
    </div>
  );
}
